import { Activity } from "lucide-react";
import useApi from "../../hooks/useApi";
import { useEffect, useState } from "react";

const InvoiceHeader = ({
  showSidebar,
  setShowSidebar,
  invoiceId,
  BASE_URL,
  COMPANY_CODE,
  DEPARTMENT,
  title,
}) => {
  const { request, loading } = useApi();
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const statusStyles = {
    PAID: {
      bg: "bg-emerald-500",
      text: "text-white",
      label: "Paid",
    },
    PARTIAL: {
      bg: "bg-amber-400",
      text: "text-white",
      label: "Partial",
    },
    UNPAID: {
      bg: "bg-red-500",
      text: "text-white",
      label: "Unpaid",
    },
  };

  const fetchInvoiceData = async () => {
    const url = `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/INVOICEINFO/${invoiceId}/${DEPARTMENT}`;
    try {
      const response = await request({ url, method: "GET" });
      return response || [];
    } catch (err) {
      console.error(`Failed to fetch invoice data:`, err);
      return [];
    }
  };

  useEffect(() => {
    const loadInvoiceData = async () => {
      const data = await fetchInvoiceData();
      setInvoiceDetails(data[0]);
      console.log("Invoice Details:", data);
    };

    if (invoiceId) {
      loadInvoiceData();
    }
  }, [invoiceId]);

  const currentStatus = statusStyles[invoiceDetails?.PAID_STATUS] || "";

  return (
    <div className="sticky z-0 bg-white border-b border-gray-100 rounded-b-lg shadow-sm">
      <div className="lg:px-4 py-2.5 border-b border-gray-50">
        <div className="flex lg:flex-row flex-col items-center lg:justify-between lg:space-y-0 space-y-3 ">
          <div className="flex items-center gap-4 lg:justify-normal justify-between lg:w-max w-full lg:px-0 px-4">
            <h1 className="text-lg font-semibold text-gray-900">{title} </h1>
            <button
              onClick={() => setShowSidebar(!showSidebar)}
              className={`inline-flex items-center gap-1.5 px-3 py-1 text-xs font-semibold rounded-full transition-all ${
                showSidebar
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
            >
              <Activity className="w-3 h-3" />
              {showSidebar ? "Hide" : "Show"} Activity
            </button>
          </div>

          <div className="flex lg:flex-row flex-col items-center gap-2">
            <div className="inline-flex items-stretch divide-x divide-gray-200 bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
              <div
                className={`flex items-center justify-center lg:px-4 px-3 py-2 lg:min-w-[100px] ${currentStatus?.bg} border-r-2 border-gray-300`}
              >
                <div
                  className={`text-sm font-bold uppercase ${currentStatus?.text}`}
                >
                  {loading ? "Loading.." : <>{currentStatus?.label}</>}
                </div>
              </div>
              <div className="lg:px-4 px-2 py-2 text-center lg:min-w-[100px] hover:bg-blue-50 transition-colors">
                <div className="text-[10px] text-gray-500 font-semibold uppercase tracking-widest mb-1">
                  Invoice
                </div>
                <div className="text-base font-extrabold text-blue-700 tabular-nums">
                  {invoiceDetails["SALES AMOUNT"]}
                </div>
              </div>
              <div className="lg:px-4 px-2 py-2 text-center lg:min-w-[100px] hover:bg-gray-50 transition-colors">
                <div className="text-[10px] text-gray-500 font-semibold uppercase tracking-widest mb-1">
                  Return
                </div>
                <div className="text-base font-extrabold text-gray-700 tabular-nums">
                  {invoiceDetails["RETURN AMOUNT"]}
                </div>
              </div>
              <div className="lg:px-4 px-2 py-2 text-center lg:min-w-[100px] hover:bg-green-50 transition-colors">
                <div className="text-[10px] text-gray-500 font-semibold uppercase tracking-widest mb-1">
                  Receipt
                </div>
                <div className="text-base font-extrabold text-green-700 tabular-nums">
                  {invoiceDetails["RECEIPT AMOUNT"]}
                </div>
              </div>
              <div className="lg:px-4 px-2 py-2 text-center lg:min-w-[100px] hover:bg-orange-50 transition-colors border-l-2 border-orange-200">
                <div className="text-[10px] text-gray-500 font-semibold uppercase tracking-widest mb-1">
                  Balance
                </div>
                <div className="text-base font-extrabold text-orange-600 tabular-nums">
                  {invoiceDetails["BALANCE AMT"]?.toLocaleString()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceHeader;
